export const STATIC_SEGMENTS_SAMPLE_CSV_URL: string =
	'https://zupee-common-test-bucket.s3.ap-south-1.amazonaws.com/prod/staticSegmentsSampleProd.csv';
export const USER_SEGMENTS_STATUS_DOC_PROD: string =
	'https://docs.google.com/spreadsheets/d/1XVzL8D-6hsrA2lLNxjCwvtTAbuD_EYOg4Ls12vx8Cug/edit#gid=0';
export const STATIC_SEGMENTS_DESC_MIN_LENGTH: number = 50;
